<div class="purple-div">
    <div class="pointer"></div>
    <p class="instruction-text">FlyMSG for Chrome/Edge has successfully installed!</p>
    <p class="instruction-text">Click the above to pin FlyMSG for easy access.</p>
    <div class="browser-img-div">
        <img src="../../../assets/images/flymsg_browser.png" height="250px">
    </div>
    <div class="bottom-div">
        <img src="../../../assets/images/flymsg_white_logo.png">
        <button class="dismiss-btn" (click)="dismissPrompt()">Dismiss</button>
    </div>
</div>